import React from 'react';

const Exports = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Exports & Turnkey Solutions</h1>
        <p>End-to-end export management and project delivery</p>
      </section>
      <section className="page-content">
        <div className="container">
          <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: '#E6D88A'}}>
            We provide comprehensive export services and turnkey solutions for businesses 
            looking to expand their international presence.
          </p>
          <div className="content-grid" style={{marginTop: '30px'}}>
            <div className="content-card">
              <h3>Export Management</h3>
              <p>Full export documentation and logistics.</p>
            </div>
            <div className="content-card">
              <h3>Turnkey Projects</h3>
              <p>Complete project delivery from concept to completion.</p>
            </div>
            <div className="content-card">
              <h3>Market Entry</h3>
              <p>Strategic market entry solutions.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Exports;